import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import Cookies from "universal-cookie";
import { ADMIN_API } from "../common/common";
import {
  getBrowser,
  getImageUrl,
  readCachedAgLoginDesign,
  readCachedLoginImages,
} from "../common/Funcation";
import { normalizeAgLoginDesign } from "../common/loginPage";
import {
  styleObjectBlackButton,
  styleObjectGetBG,
  styleObjectGetBGasColor,
} from "../common/StyleSeter";
import { notifyError, notifyMessage, postApi } from "../service";
import instagram from "./../assets/icons/instagram.svg";
import mail from "./../assets/icons/mail.svg";
import skype from "./../assets/icons/skype.svg";
import telegram from "./../assets/icons/telegram.svg";
import whatsapp from "./../assets/icons/whatsapp.svg";
const cookies = new Cookies();
const ChangePassword = () => {
  const [, updateState] = React.useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [formData, setFormData] = useState({
    newPassword: "",
    conformPassword: "",
    currentPassword: "",
  });
  const SocialIcon = [
    { iconStatus: true, link: "", image: mail, name: "mail" },
    { iconStatus: true, link: "", image: whatsapp, name: "whatsapp" },
    { iconStatus: true, link: "", image: telegram, name: "telegram" },
    { iconStatus: true, link: "", image: skype, name: "skype" },
    { iconStatus: true, link: "", image: instagram, name: "instagram" },
  ];
  const SocialContact = ["+918888899999", "+918888897779", "+91888884399"];
  const [confirmationCode] = useState(Math.floor(1000 + Math.random() * 9000));
  const [isValidationWrong, setIsValidationWrong] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.outerWidth < 900,
  );
  const DD = useSelector((e: any) => e.domainDetails);
  const domainDetailsLoaded = useSelector((e: any) => e.domainDetailsLoaded);
  const cachedAgLogin = React.useMemo(() => readCachedAgLoginDesign(), []);
  const cachedLoginImages = React.useMemo(() => readCachedLoginImages(), []);
  const agLoginDesign = DD?._id
    ? normalizeAgLoginDesign(DD?.agLoginDesign)
    : cachedAgLogin;
  const isVelki = agLoginDesign === "velki";

  const [isHover, setIsHover] = useState(false);
  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };

  useEffect(() => {
    if (!isVelki) return;
    const meta = document.querySelector('meta[name="viewport"]');
    const previous = meta?.getAttribute("content") || "width=1350";
    meta?.setAttribute(
      "content",
      "width=device-width, initial-scale=1, viewport-fit=cover",
    );
    document.body.classList.add("velki-ag-active");
    document.documentElement.classList.add("velki-ag-active");
    document.documentElement.classList.add("velki-ag-boot");

    const sync = () => {
      setIsMobile(window.outerWidth < 900 || window.innerWidth < 768);
    };
    sync();
    window.addEventListener("resize", sync);
    return () => {
      window.removeEventListener("resize", sync);
      meta?.setAttribute("content", previous);
      document.body.classList.remove("velki-ag-active");
      document.documentElement.classList.remove("velki-ag-active");
      document.documentElement.classList.remove("velki-ag-boot");
    };
  }, [isVelki]);

  const handelInputChange = (e: any) => {
    const { name, value } = e.target;
    setIsValidationWrong(false);
    setFormData({ ...formData, [name]: value });
  };
  const handelSubmit = async (e: any) => {
    e.preventDefault();
    if (Validator.current.allValid()) {
      setIsValidationWrong(false);
      const systemDetails = getBrowser();

      let data = {
        api: ADMIN_API.CHANGE_PASSWORD,
        value: {
          currentPassword: formData.currentPassword,
          newPassword: formData.newPassword,
          conformPassword: formData.conformPassword,
          browser_detail:
            systemDetails.BrowserName + " V" + systemDetails.BrowserVersion,
          systemDetail: systemDetails.OSname + " V" + systemDetails.OSversion,
        },
        token: cookies.get("skyToken"),
      };
      await postApi(data)
        .then(function (response) {
          cookies.set("skyToken", response.data.data.token, {
            domain: process.env.REACT_APP_COOKIE_DOMAIN,
            path: "/",
          });
          dispatch({
            type: "AUTHENTICATION",
            payload: {
              isLogin: true,
              token: response.data.data.token,
              changePassword: false,
            },
          });

          notifyMessage("change password successfully");
          setTimeout(() => {
            window.location.href = "/";
          }, 500);
          // navigate('/')
        })
        .catch((err) => {
          notifyError(err.response.data.message);

          if (err.response.data.statusCode === 401) {
            // Logout()
            // navigate('/login')
          }
        });
    } else {
      // debugger;
      Validator.current.showMessages();
      forceUpdate();
    }
  };
  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: this,
    })
  );

  if (!domainDetailsLoaded && !DD?._id && cachedAgLogin !== "default") {
    return <div className="ag-login-hold" />;
  }

  if (isVelki) {
    const logoUrl = getImageUrl(
      DD?.agLoginLogo ||
        cachedLoginImages?.agLoginLogo ||
        DD?.adminLogo ||
        DD?.logo,
    );
    const velkiBg = `${process.env.PUBLIC_URL || ""}/velki-ag-bg.jpg`;
    const newPasswordError = Validator.current.message(
      "new password",
      formData.newPassword,
      "required",
    );
    const confirmPasswordError = Validator.current.message(
      "confirm password",
      formData.conformPassword,
      "required",
    );
    const currentPasswordError = Validator.current.message(
      "current password",
      formData.currentPassword,
      "required",
    );
    return (
      <>
        <Helmet>
          <title>{DD?.title || "Change Password"}</title>
        </Helmet>
        <div
          className={`velki-ag-login velki-ag-login--password${isMobile ? " is-mobile" : ""}`}
          style={{ backgroundImage: `url(${velkiBg})` }}
        >
          <div className="velki-ag-panel">
            {logoUrl ? (
              <img
                className="velki-ag-logo"
                src={logoUrl}
                alt={DD?.title || "Agent"}
              />
            ) : (
              <div className="velki-ag-logo velki-ag-logo--empty" />
            )}
            <form className="velki-ag-form" onSubmit={(e) => handelSubmit(e)}>
              <h3 className="velki-ag-title">
                <span>Change</span> Password
              </h3>
              <ul className="velki-ag-rules">
                <li>8 to 15 letters or numbers, no spaces</li>
                <li>Cannot match your username</li>
                <li>At least 1 capital, 1 small letter, and 1 number</li>
                <li>No special characters</li>
              </ul>
              <div className="velki-ag-field">
                <input
                  type={showPassword ? "text" : "password"}
                  name="newPassword"
                  value={formData.newPassword}
                  onChange={handelInputChange}
                  placeholder="New Password"
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="velki-ag-eye"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    {showPassword ? (
                      <path d="M3 3l18 18M10.6 10.6A3 3 0 0012 15a3 3 0 002.4-4.8M9.9 5.2A10.8 10.8 0 0112 5c5 0 9.3 3.1 11 7.5a11.7 11.7 0 01-4.1 5.2M6.1 6.1A11.8 11.8 0 001 12.5C2.7 16.9 7 20 12 20c1.1 0 2.2-.2 3.2-.5" />
                    ) : (
                      <path d="M1 12.5C2.7 8.1 7 5 12 5s9.3 3.1 11 7.5C21.3 16.9 17 20 12 20S2.7 16.9 1 12.5zM12 16a3.5 3.5 0 100-7 3.5 3.5 0 000 7z" />
                    )}
                  </svg>
                </button>
                {newPasswordError ? (
                  <span className="velki-ag-error">{newPasswordError}</span>
                ) : null}
              </div>
              <div className="velki-ag-field">
                <input
                  type={showPassword ? "text" : "password"}
                  name="conformPassword"
                  value={formData.conformPassword}
                  onChange={handelInputChange}
                  placeholder="Confirm Password"
                  autoComplete="new-password"
                />
                {confirmPasswordError ? (
                  <span className="velki-ag-error">{confirmPasswordError}</span>
                ) : null}
              </div>
              <div className="velki-ag-field">
                <input
                  type={showPassword ? "text" : "password"}
                  name="currentPassword"
                  value={formData.currentPassword}
                  onChange={handelInputChange}
                  placeholder="Current Password"
                  autoComplete="current-password"
                />
                {currentPasswordError ? (
                  <span className="velki-ag-error">{currentPasswordError}</span>
                ) : null}
              </div>
              <button
                type="submit"
                className="velki-ag-submit"
                style={{ marginTop: "9px" }}
              >
                Change
              </button>
            </form>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="login_main changepass">
      <div
        className="login_main_popup "
        // style={styleObjectGetBG(DD?.colorSchema)}
      >
        <div className="login_main_popup_wrp">
          <div
            className="login_main_popup_left "
            // style={styleObjectGetBG(DD?.colorSchema)}
          >
            <ul>
              <li>
                Password must have 8 to 15 alphanumeric without white space
              </li>
              <li>Password cannot be the same as username/nickname</li>
              <li>
                Must contain at least 1 capital letter, 1 small letter and 1
                number
              </li>
              <li>
                Password must not contain any special characters (!,@,#,etc..)
              </li>
            </ul>
          </div>
          <div className="login_form_main">
            <h3 className="form_title"> Change Password </h3>
            <form className="login_form" onSubmit={(e) => handelSubmit(e)}>
              <InputGroup
                name="newPassword"
                value={formData.newPassword}
                type="password"
                onChange={handelInputChange}
                placeholder="New Password"
                errorValidation={Validator.current.message(
                  "newPassword",
                  formData.newPassword,
                  "required"
                )}
              />
              <InputGroup
                name="conformPassword"
                value={formData.conformPassword}
                type="password"
                onChange={handelInputChange}
                placeholder="New Password Confirm"
                errorValidation={Validator.current.message(
                  "conformPassword",
                  formData.conformPassword,
                  "required"
                )}
              />
              <InputGroup
                name="currentPassword"
                value={formData.currentPassword}
                type="password"
                onChange={handelInputChange}
                placeholder="Old Password"
                errorValidation={Validator.current.message(
                  "currentPassword",
                  formData.currentPassword,
                  "required"
                )}
              />

              {isValidationWrong ? (
                <span className="error" style={{ color: "red" }}>
                  invalid verification code
                </span>
              ) : (
                ""
              )}
              <button
                type="submit"
                style={styleObjectGetBGasColor(DD?.colorSchema)}
                className="w-100 btn_black hover-border"
                onSubmit={(e) => handelSubmit(e)}
              >
                Change
              </button>
            </form>
          </div>
        </div>
        <div className="maintain-footer">
          <img src={getImageUrl(DD?.logo)} alt="logo" />
        </div>
      </div>

      {/* <div className='login_footer'>
                <div className='login_footer_social'>
                    {SocialIcon.map((item) => <div className="social_icon">
                        <img src={item.image} alt={item.name} />
                    </div>)}
                </div>
                <div className="login_footer_contact">
                    {SocialContact.map((item) => (
                        <span>{item}</span>
                    ))}
                </div>
            </div> */}
    </div>
  );
};

export default ChangePassword;

export const InputGroup = (props: any) => {
  const { type, placeholder, name, value, onChange, errorValidation } = props;
  return (
    <div className="input_group">
      <input
        type={type}
        name={name}
        value={value}
        onChange={(e) => onChange(e)}
        placeholder={placeholder}
      />
      {errorValidation ? (
        <span className="error" style={{ color: "red" }}>
          {errorValidation}
        </span>
      ) : (
        ""
      )}
    </div>
  );
};
